import { getCodeFromErrors, getExtensionFromErrors } from '@common/components';
import type { ApolloError } from '@common/hooks';

// NOTE: each string names the state only; the backend message can carry
// internal ids and is never surfaced to the user.
const NOT_APPROVABLE_COPY: Record<string, string> = {
  confirmed: 'This shift has already been approved.',
  cancelled: 'This shift has been cancelled and can no longer be approved.',
  rejected: 'This shift was rejected and can no longer be approved.',
  retracted:
    'This shift was retracted by the worker and can no longer be approved.',
};

const NOT_APPROVABLE_FALLBACK =
  'This shift can no longer be approved. Refresh to see its latest status.';

const GENERIC_ERROR = 'Failed to change works shift state. Please try again.';

export function performWorksShiftActionErrorMessage(error: ApolloError): {
  kind: 'warning' | 'error';
  message: string;
} {
  if (getCodeFromErrors(error.graphQLErrors) === 'SHIFT_NOT_APPROVABLE') {
    const state = getExtensionFromErrors(error.graphQLErrors, 'currentState');
    return {
      kind: 'warning',
      message: (state && NOT_APPROVABLE_COPY[state]) || NOT_APPROVABLE_FALLBACK,
    };
  }
  return { kind: 'error', message: GENERIC_ERROR };
}
